import { SxProps, Theme } from '@mui/material'

export const checkboxLabelSx: SxProps<Theme> = {
  alignItems: 'flex-start',
  py: 0,
  '& .MuiCheckbox-root': {
    py: 0.5,
  },
  '& .MuiFormControlLabel-label': {
    pt: '5px',
    lineHeight: 1.4,
  },
}

export const MEDICAL_SPECIALTIES = [
  'Acupuntura (exercido por médico com CRM)',
  'Alergia e Imunologia',
  'Anestesiologia ou Anestesista',
  'Angiologia sem cirurgia',
  'Cancerologia sem Cirurgia',
  'Cardiologia sem Cirurgia',
  'Cirurgia Bariátrica',
  'Cirurgia Cardiovascular',
  'Cirurgia da Mão',
  'Cirurgia de Cabeça e Pescoço',
  'Cirurgia de Coluna',
  'Cirurgia do Aparelho Digestivo exceto Cirurgia Bariátrica',
  'Cirurgia Geral',
  'Cirurgia Pediátrica',
  'Cirurgia Plástica',
  'Cirurgia Torácica',
  'Cirurgia Vascular ou Cardiologia Intervencionista',
  'Clínica Médica com Procedimentos Invasivos',
  'Clínica Médica sem Procedimentos Invasivos',
  'Coloproctologia com Cirurgia',
  'Coloproctologia sem Cirurgia',
  'Dermatologia Clínica sem Estética',
  'Dermatologia ou Estética com Procedimentos Invasivos',
  'Dermatologia ou Estética sem Procedimentos Invasivos',
  'Endocrinologia e Metabologia',
  'Endoscopia (Todos os Tratos)',
  'Gastroenterologia sem Cirurgia e com Balão Intragástrico',
  'Gastroenterologia sem Cirurgia e sem Balão Intragástrico',
  'Genética Médica',
  'Geriatria',
  'Ginecologia com Cirurgia mas sem Partos',
  'Ginecologia sem Cirurgia ou Partos',
  'Ginecologia com Obstetrícia',
  'Hematologia e Hemoterapia (sem Cirurgia)',
  'Homeopatia',
  'Infectologia',
  'Mastologia com Cirurgia',
  'Mastologia sem Cirurgia',
  'Medicina de Família e Comunidade',
  'Medicina do Tráfego',
  'Medicina do Trabalho',
  'Medicina de Urgência; Plantão PS',
  'Medicina Esportiva exceto Atletas Profissionais',
  'Medicina Física e Reabilitação exceto Atletas Profissionais',
  'Medicina Intensiva; Atuação em UTI ou UTI Neonatal',
  'Medicina Legal e Perícia Médica',
  'Medicina Nuclear',
  'Medicina Preventiva e Social',
  'Nefrologia',
  'Neurocirurgia',
  'Neurologia',
  'Nutrologia',
  'Oftalmologia com Cirurgia',
  'Oftalmologia sem Cirurgia',
  'Ortopedia e Traumatologia com Cirurgia',
  'Ortopedia e Traumatologia sem Cirurgia',
  'Otorrinolaringologia com Cirurgia',
  'Otorrinolaringologia sem Cirurgia',
  'Patologia Clínica ou Medicina Laboratorial com Punção de Vasos ou Tecidos',
  'Patologia Clínica ou Medicina Laboratorial sem Punção de Vasos ou Tecidos',
  'Pediatria sem Cirurgia',
  'Pneumologia',
  'Psiquiatria',
  'Radiologia e Diagnóstico por Imagem com Punção de Vasos ou Tecidos',
  'Radiologia e Diagnóstico por Imagem sem Punção de Vasos ou Tecidos',
  'Radioterapia',
  'Reumatologia',
  'Urologia com Cirurgia',
  'Urologia sem Cirurgia',
] as const

export const PROFESSIONAL_CATEGORIES = [
  { value: 'medicos', label: 'MÉDICOS' },
  { value: 'odontologia', label: 'PROFISSIONAIS DE ODONTOLOGIA' },
  { value: 'demais_profissionais', label: 'DEMAIS PROFISSIONAIS DA SAÚDE' },
] as const

export type ProfessionalCategory =
  (typeof PROFESSIONAL_CATEGORIES)[number]['value']

export const DENTAL_SPECIALTIES = [
  'Odontologia: Auxiliar ou Técnico em Saúde Bucal e Prótese Dentária',
  'Odontologia e Implantodontia (não inclui cirurgia bucomaxilofacial, proced. estéticos da face e harmonização orofacial)',
  'Odontologia com Implantodontia, Cirurgia Bucomaxilofacial, Proced. Estéticos da face e Harmonização Orofacial',
  'Odontologia Clínica e cirúrgica (não inclui implantes, cirurgia bucomaxifacial, proced. estéticos da face e harmonização orofacial)',
] as const

export const OTHER_HEALTH_SPECIALTIES = [
  'Acupuntura (exercida por demais Profissionais)',
  'Auxiliar de Enfermagem',
  'Biólogo com Manipulação',
  'Paramédico, Socorrista, Técnico Emergência',
  'Esteticista com Proced Invasivos',
  'Biomédico com Punção',
  'Biomédico sem Punção e sem Estética',
  'Bioquímico com Manipulação',
  'Bioquímico sem Manipulação',
  'Cuidadoria (exclui Punção E Aplicação de Subst por Sonda)',
  'Enfermagem Obstétrica',
  'Enfermeiro exceto Enfermeiro OBstetriz',
  'Biólogo sem Manipulação',
  'Esteticista sem Proced Invasivos',
  'Farmacêutico com Manipulação de Medicamentos',
  'Farmacêutico sem Manipulação de Medicamentos',
  'Fisioterapia sem Estética ou Punção',
  'Psicologia',
  'Fonoaudiologia',
  'Nutrição ou Nutricionista',
  'Técnico em Enfermagem',
  'Técnico em Radiologia',
  'Tecnol ou Tec em Biomed sem Estética',
  'Terapia Ocupacional',
] as const

export function specialtiesForCategories(
  categories: readonly ProfessionalCategory[],
): string[] {
  const specialties: string[] = []

  if (categories.includes('medicos')) {
    specialties.push(...MEDICAL_SPECIALTIES)
  }

  if (categories.includes('demais_profissionais')) {
    specialties.push(...OTHER_HEALTH_SPECIALTIES)
  }

  if (categories.includes('odontologia')) {
    specialties.push(...DENTAL_SPECIALTIES)
  }

  return specialties
}

export const COVERAGE_OPTIONS = [
  { label: 'R$ 100.000', value: 100000 },
  { label: 'R$ 200.000', value: 200000 },
  { label: 'R$ 300.000', value: 300000 },
  { label: 'R$ 400.000', value: 400000 },
  { label: 'R$ 500.000', value: 500000 },
  { label: 'R$ 700.000', value: 700000 },
  { label: 'R$ 1.000.000', value: 1000000 },
  { label: 'R$ 1.500.000', value: 1500000 },
] as const

export const PHONE_TYPE_OPTIONS = [
  { label: 'Celular', value: 'celular' },
  { label: 'Comercial', value: 'comercial' },
  { label: 'Residencial', value: 'residencial' },
] as const

export const INSURANCE_KIND_OPTIONS = [
  { label: 'Seguro novo', value: 'new' },
  { label: 'Renovação de outra companhia', value: 'renewal' },
] as const

export const MARITAL_STATUS_OPTIONS = [
  { label: 'Solteiro(a)', value: 'solteiro' },
  { label: 'Casado(a)', value: 'casado' },
  { label: 'Viúvo(a)', value: 'viuvo' },
  { label: 'Desquitado(a)', value: 'desquitado' },
  { label: 'Divorciado(a)', value: 'divorciado' },
] as const

export const SEX_OPTIONS = [
  { label: 'Masculino', value: 'masculino' },
  { label: 'Feminino', value: 'feminino' },
] as const

export const YES_NO_OPTIONS = [
  { label: 'Sim', value: true },
  { label: 'Não', value: false },
]

export const FORM_STEPS = [
  'Cadastro',
  'Questionário',
  'Dados do seguro',
] as const
